module.exports = __webpack_public_path__ + "img/primary_data_merge_active.caae7402.svg";